import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no-projects-dansuk.png'


const _withScopeId = n => (_pushScopeId("data-v-1929d0d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-container relative" }
const _hoisted_2 = {
  key: 0,
  class: "main-container no-projects"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "No projects"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Henüz hiçbir projeniz yok. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Eğer yetkiniz varsa, hemen yeni bir proje oluşturabilirsiniz. Eğer proje oluşturmaya yönelik bir buton görmüyorsanız, lütfen ekibinizden sizi bir projeye eklemelerini isteyin. ", -1))
const _hoisted_6 = {
  key: 1,
  class: "ai-chat main-container"
}
const _hoisted_7 = { class: "chat-area-container" }
const _hoisted_8 = { class: "chat-area" }
const _hoisted_9 = {
  key: 0,
  class: "notification bg-yellow-500 text-white top-24 left-[7%] absolute p-4 rounded-lg border border-orange-300"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Bu proje için kullanılacak veri kaynağı şu anda işleniyor. Seçtiğiniz dosya / klasörün boyutuna göre bu işlem birkaç dakika sürebilir. Lütfen veri kaynağının aktarılmasını bekleyin. ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disappear-zone" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "no-messages"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anchor" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, " > ", -1))
const _hoisted_17 = [
  _hoisted_16
]

import acLoader from "@/components/reusable/acLoader.vue"
import AiMessageDisplayer from "./components/aiMessageDisplayer.vue"
import ChatTextarea from "./components/chatTextarea.vue"
import CollaborativeSidebar from "./components/collaborativeSidebar.vue"
import StepAddAiProjectForm from "./components/stepCreateProjectForm.vue"
import TeleportsAcMediumModal from "../reusable/teleports/acMediumModal.vue"
import { createNewProject, assignProjectToUser, useGetAllProjectMessages, postProjectMessage, processAIProject } from "@/composables/aiChatFunctions"
import { modalClosed } from "@/mixins/visualFormatters"
import type { AICollabMessage, AICollabProject } from "@/types"
import { useStore } from 'vuex';
import { computed, watch, ref, onMounted, nextTick } from 'vue';
import { postData } from "@/mixins/modularFirebaseOperations"
import ProcessedFilesDisplayer from "./components/processedFilesDisplayer.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'collaborativeChat',
  setup(__props) {


const store = useStore()
const isAIWriting = ref(false)
const selectedProject = computed(() => store.getters['ai/selectedProject']);
const userProfile = computed(() => store.getters['user/userProfile']);
const chatMessageContainer = ref(null);
const collaborativeSidebarRef = ref(null);
const user = {
    id: userProfile.value.uid,
    email: userProfile.value.email,
    name: userProfile.value.name,
    picture: userProfile.value.picture,
    allowsEdit: userProfile.value.allowsEdit
}


const isFileListDisplayed = ref(true)
const isCreatingProject = ref(false)


const toggleFileListDisplay = () => {
    isFileListDisplayed.value = !isFileListDisplayed.value
}
const handleProjectCreated = async (project: AICollabProject) => {
    
    // Assign the project to the user who created it

    project.members.push({
        id: user.id,
        name: user.name,
    })


    try {
        // First, create the project in the database
        const newProjectId = await createNewProject(project)
        if (newProjectId) {


            // Then, assign the project to the users
            for (const member of project.members) {
                await assignProjectToUser(newProjectId, member.id)
            }
            // Refresh the projects list in the sidebar
            await collaborativeSidebarRef.value?.refreshProjects()
            store.dispatch('ai/setSelectedProject', newProjectId)
            
            // MAke a request to the backend to start processing project info

            await processAIProject(newProjectId)
        }
    } catch (error) {
        alert("Error creating project: " + error)
    } finally {
        isCreatingProject.value = false
        modalClosed()
    }
}

// Create refs to hold chat messages and loading state
const chatMessages = ref<AICollabMessage[]>([]);
const isLoadingChatMessages = ref(false);

let cleanup = null;
const aiResponseReceivedRef = ref(false);

// Function to update chat messages when session changes
const updateChatMessages = () => {
    // Clean up previous listener if it exists
    if (cleanup) {
        cleanup();
    }
    
    // Only fetch messages if we have a valid session
    if (selectedProject.value && selectedProject.value.id) {
        const result = useGetAllProjectMessages(
            selectedProject.value.id, 
        );
        
        // Update our refs
        chatMessages.value = result.messages.value;
        isLoadingChatMessages.value = result.isLoadingMessages.value;
        cleanup = result.cleanup;
        
        // Update the aiResponseReceived ref
        aiResponseReceivedRef.value = result.aiResponseReceived.value;
        
        // Set up a direct watcher for messages to detect AI responses
        watch(result.messages, (newMessages) => {
            // Check if the last message is from AI
            if (newMessages.length > 0 && newMessages[newMessages.length - 1].type === 'ai') {
                isAIWriting.value = false;
                scrollToBottom();
            }
        }, { deep: true });
    }
};

// Watch for AI response to update isAIWriting state
watch(() => aiResponseReceivedRef.value, (newValue) => {
    if (newValue) {
        isAIWriting.value = false;
        // Scroll to bottom when AI response is received
        scrollToBottom();
    }
}, { immediate: true });

// Watch for changes in chatMessages to scroll to bottom when new messages are added
watch(chatMessages, (newMessages) => {
    scrollToBottom();
    
    // Check if the last message is from AI and we're still in AI writing state
    if (newMessages.length > 0 && 
        newMessages[newMessages.length - 1].type === 'ai' && 
        isAIWriting.value) {
        isAIWriting.value = false;
    }
}, { deep: true });

// Initialize chat messages after component is mounted
onMounted(() => {
    updateChatMessages();
});

// Watch for changes in selectedSession
watch(selectedProject, () => {
    updateChatMessages();
}, { deep: true });

const messagePosted = async (message: string) => {

    if(message.length === 0) {
        return;
    }

    const userMessage: AICollabMessage = {
            id: 'temp-' + Date.now(), // Temporary ID that will be replaced by Firebase
            content: message,
            type: 'human',
            timestamp: new Date(),
            from: user // Add the from field with the current user
        };

    if(message.startsWith('@')) {
        const cleanMessage = {
            content: message,
            type: 'human',
            timestamp: new Date(),
            from: user
        };
        await postData(cleanMessage, `ai/collective/projects/${selectedProject.value.id}/messages`)
        return;
    }

    try {
        // Reset aiResponseReceived to ensure we catch the next response
        aiResponseReceivedRef.value = false;
        
        // Add user message to UI immediately

        chatMessages.value.push(userMessage);
        
        // Scroll to bottom to show the new message
        scrollToBottom();
        
        // Set AI writing state
        isAIWriting.value = true;
        
        // Set a timeout to reset isAIWriting if no response is received
        const timeoutId = setTimeout(() => {
            isAIWriting.value = false;
        }, 10000); // 10 seconds timeout
        
        // Send message to backend
        await postProjectMessage(message, selectedProject.value.id, user);
        
        // Clear the timeout since we're waiting for the real-time listener to update isAIWriting
        clearTimeout(timeoutId);
        
        // Set a shorter timeout to check if we need to manually reset isAIWriting
        setTimeout(() => {
            // If we're still in AI writing state after 5 seconds, check if we have an AI message
            if (isAIWriting.value && chatMessages.value.length > 0) {
                const lastMessage = chatMessages.value[chatMessages.value.length - 1];
                if (lastMessage.type === 'ai') {
                    isAIWriting.value = false;
                }
            }
        }, 5000);
        
        // AI writing state will be cleared when the real-time listener receives the AI response
    } catch (error) {
        console.error(error);
        isAIWriting.value = false;
    }
}

const handleProjectChanged = (projectId: string) => {
    store.dispatch('ai/setSelectedProject', projectId)
    
}

const scrollToBottom = async () => {
    await nextTick();

    // Use a shorter timeout to make it more responsive
    setTimeout(() => {
        if (chatMessageContainer.value) {
            chatMessageContainer.value.scrollTop = chatMessageContainer.value.scrollHeight;
            
            // Add a second scroll after a short delay to ensure it works even if content is still loading
            setTimeout(() => {
                if (chatMessageContainer.value) {
                    chatMessageContainer.value.scrollTop = chatMessageContainer.value.scrollHeight;
                }
            }, 100);
        }
    }, 50);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!selectedProject.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          (userProfile.value.allowsEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ac-primary-button text-2xl",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isCreatingProject.value = true))
              }, " Proje Oluştur "))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(CollaborativeSidebar, {
            onCreateNewProject: _cache[1] || (_cache[1] = ($event: any) => (isCreatingProject.value = true)),
            onProjectChanged: handleProjectChanged,
            ref_key: "collaborativeSidebarRef",
            ref: collaborativeSidebarRef
          }, null, 512),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (selectedProject.value.isProcessingInfoBase && chatMessages.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                ref_key: "chatMessageContainer",
                ref: chatMessageContainer,
                id: "chatMessages",
                class: "chat-messages-container"
              }, [
                _hoisted_12,
                (isLoadingChatMessages.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(acLoader)
                    ]))
                  : (chatMessages.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Henüz hiç mesaj yok. "))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatMessages.value, (message) => {
                  return (_openBlock(), _createBlock(AiMessageDisplayer, {
                    key: message.id,
                    message: message,
                    collab: true,
                    mine: message.from?.id === user.id
                  }, null, 8, ["message", "mine"]))
                }), 128)),
                _hoisted_15
              ], 512)
            ]),
            _createVNode(ChatTextarea, {
              id: "collabTextArea",
              onMessagePosted: messagePosted,
              isAIWriting: isAIWriting.value,
              projectMembers: selectedProject.value?.members || [] 
            }, null, 8, ["isAIWriting", "projectMembers"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([{'is-displayed': isFileListDisplayed.value}, "file-display-area relative"])
          }, [
            (selectedProject.value.processedFiles && selectedProject.value.processedFiles.length > 0 && isFileListDisplayed.value)
              ? (_openBlock(), _createBlock(ProcessedFilesDisplayer, {
                  key: 0,
                  class: "processed-files-displayer"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: _normalizeClass([{'not-displayed': !isFileListDisplayed.value}, "close-button"]),
              type: "button",
              onClick: toggleFileListDisplay
            }, _hoisted_17, 2)
          ], 2)
        ])),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }, {
      default: _withCtx(() => [
        (isCreatingProject.value)
          ? (_openBlock(), _createBlock(TeleportsAcMediumModal, {
              key: 0,
              title: "Proje Oluştur",
              width: "50vw",
              height: "60vh",
              onModalClosed: _cache[3] || (_cache[3] = ($event: any) => {isCreatingProject.value = false; })
            }, {
              default: _withCtx(() => [
                _createVNode(StepAddAiProjectForm, {
                  onCancelled: _cache[2] || (_cache[2] = ($event: any) => {isCreatingProject.value = false; _unref(modalClosed)()}),
                  onSubmitted: handleProjectCreated
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})